export enum BenchmarkGranularity {
    WEEKLY = "Weekly",
    MONTHLY = "Monthly",
}

export const TOP_RANK = 5;
